/**
 * Calculates styles and values for selection wrapper components
 */
export interface SelectionWrapperStylesOptions {
  selected?: boolean;
  invalid?: boolean;
  originalRadius?: number;
  selectedWrapperGap?: number;
}

export interface SelectionWrapperStylesResult {
  showWrapper: boolean;
  wrapperGap: number;
  wrapperRadius: number;
  contentRadius: number;
  expansionOffset: number;
  wrapperStyle: { margin: string; borderRadius: string; padding: number };
  contentStyle: { borderRadius: string };
}

export function calculateSelectionWrapperStyles({
  selected = false,
  invalid = false,
  originalRadius = 6,
  selectedWrapperGap = 3,
}: SelectionWrapperStylesOptions = {}): SelectionWrapperStylesResult {
  // Show wrapper if selected OR invalid
  const showWrapper = selected || invalid;

  // Add gap only when selected (regardless of valid/invalid state)
  const wrapperGap = selected ? selectedWrapperGap : 0;

  const wrapperRadius = showWrapper
    ? originalRadius + wrapperGap
    : originalRadius;

  const contentRadius = Math.max(0, originalRadius);

  // Expand only when selected (for both valid and invalid)
  const expansionOffset = selected ? selectedWrapperGap : 0;

  return {
    showWrapper,
    wrapperGap,
    wrapperRadius,
    contentRadius,
    expansionOffset,
    wrapperStyle: {
      margin: expansionOffset > 0 ? `-${expansionOffset}px` : "0px",
      borderRadius: `${wrapperRadius}px`,
      padding: wrapperGap,
    },
    contentStyle: { borderRadius: `${contentRadius}px` },
  };
}
